module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/food-to-go-categories/food-to-go-categories.component.css
// module id = ./src/app/food-to-go-categories/food-to-go-categories.component.css
// module chunks = main